import { useEffect } from 'react';

/** Sets the browser tab title to "<title> – Soji" while the calling page is mounted. */
export function useDocumentTitle(title: string) {
    useEffect(() => {
        const previous = document.title;
        document.title = `${title} – Soji`;
        return () => {
            document.title = previous;
        };
    }, [title]);
}
